// aiEndpointAllowlist — S-024: gate custom AI-workflow-endpoints mot
// en allowlist innan hela konversation + persona + workflow-state POSTas
// dit. Samma hot-modell som S-012 (admin-sidan): localStorage kan
// komprometteras via XSS eller browser-extension → full chat-historia +
// IP-känsligt workflow-state går till attacker.example.
//
// Allowlist + helpers delas med admin-AI via adminAiEndpointAllowlist.ts.
// Denna fil är wrapper:n för user-facing-AI (AiAssistantDialog) så
// import-stigen blir logisk — user-AI importerar inte från admin-pathen.
//
// Pure: inga side-effekter. URL-parse via `new URL()` så ogiltiga
// strings → isAllowedAiEndpoint returnerar false.

import {
  isAllowedEndpoint,
  explainRejection as explainRejectionShared,
  DEFAULT_ALLOWLIST,
  type AllowlistOptions,
} from './adminAiEndpointAllowlist';

export { DEFAULT_ALLOWLIST };
export type { AllowlistOptions };

/**
 * Returnerar true om `url` pekar på en tillåten AI-endpoint. Tunna wrapper:n
 * kring `isAllowedEndpoint` — syftet är att AiAssistantDialog importerar från
 * en logisk fil (aiEndpointAllowlist, inte adminAiEndpointAllowlist).
 */
export function isAllowedAiEndpoint(
  url: string | null | undefined,
  opts: AllowlistOptions = {},
): boolean {
  return isAllowedEndpoint(url, opts);
}

/**
 * Human-readable varnings-text för user-AI. Samma meddelande-struktur som
 * admin-sidan, men formulerad så user förstår att det är workflow-data som
 * blockeras (inte bug-/feature-report-context).
 */
export function explainAiRejection(url: string | null | undefined): string {
  if (!url) return 'Ingen AI-endpoint konfigurerad.';
  try {
    const host = new URL(url).hostname;
    return `AI-endpoint "${host}" är inte i allowlist — chatten vägrar skicka workflow-data dit. Kontrollera endpoint-inställningarna eller välj en betrodd provider.`;
  } catch {
    return explainRejectionShared(url);
  }
}
